"use client";
import { motion } from "motion/react";
import { Users as UsersIcon, XCircle } from "lucide-react";

interface PolicySectionProps {
  childPolicyHTML: string;
  cancellationPolicyHTML: string;
}

export default function PolicySection({
  childPolicyHTML,
  cancellationPolicyHTML,
}: PolicySectionProps) {
  return (
    <div className="grid grid-cols-1 gap-8">
      {/* Child Policy */}
      {childPolicyHTML && (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="bg-[#F9F7F4] rounded-2xl p-6"
        >
          <div className="flex items-center gap-3 mb-4">
            <UsersIcon className="h-6 w-6 text-[#B42025]" />
            <h3 className="text-xl text-[#1A1A1A]">Child Policy</h3>
          </div>
          <div
            className="prose prose-sm max-w-none child-policy"
            dangerouslySetInnerHTML={{ __html: childPolicyHTML }}
          />
        </motion.div>
      )}

      {/* Cancellation Policy */}
      {cancellationPolicyHTML && (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="bg-[#F9F7F4] rounded-2xl p-6"
        >
          <div className="flex items-center gap-3 mb-4">
            <XCircle className="h-6 w-6 text-[#B42025]" />
            <h3 className="text-xl text-[#1A1A1A]">Cancellation Policy</h3>
          </div>
          <div
            className="prose prose-sm max-w-none cancellation-policy"
            dangerouslySetInnerHTML={{ __html: cancellationPolicyHTML }}
          />
        </motion.div>
      )}
    </div>
  );
}
